import { render, staticRenderFns } from "./TableMetadataSelectorMenu.vue?vue&type=template&id=1aae6eba&scoped=true&"
import script from "./TableMetadataSelectorMenu.vue?vue&type=script&lang=js&"
export * from "./TableMetadataSelectorMenu.vue?vue&type=script&lang=js&"
import style0 from "./TableMetadataSelectorMenu.vue?vue&type=style&index=0&id=1aae6eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aae6eba",
  null
  
)

export default component.exports